// extracted by mini-css-extract-plugin
module.exports = {"tabNav":"AdminControlsTabs_tabNav__3ocU8","active":"AdminControlsTabs_active__3-nFQ"};